// extracted by mini-css-extract-plugin
export var measureBox = "_bm-0";